import { render, staticRenderFns } from "./PrintSeminarParticipants.vue?vue&type=template&id=7a2482b0&"
import script from "./PrintSeminarParticipants.vue?vue&type=script&lang=js&"
export * from "./PrintSeminarParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports